export default __webpack_public_path__ + "static/media/MollierRotary.e3007b94.svg";